module.exports = __webpack_public_path__ + "img/ico4.64e8f2c3.png";